module.exports = __webpack_public_path__ + "static/media/belfast.a9783305.png";